<priva-dialog
    [hasFooter]="true"
    [title]="title | translate"
    [subTitle]="activity | subtitle"
    [headerButtons]="[]"
    (close)="doNothing()"
    [buttons]="buttons"
    (buttonClick)="endBreak()"
    (backdropClick)="doNothing()"
    [width]="'300'"
/>
